import { IPosition } from "../shared/types";
import { positionVolumeUSD } from "./processVolumeData";

/**
 * Volume provided by these positions: Σ fees / fee tier over the positions, computed directly
 * (no bucketing), so it equals the sum of processVolumeData's buckets for any timeframe.
 */
export const calculateTotalVolume = (positions: IPosition[]): number =>
  (positions || []).reduce((acc, position) => acc + positionVolumeUSD(position), 0);
